import { useResponsiveness } from '../../responsiveness/useResponsiveness';
import { LayoutType } from '../../types';
import { BackLink } from '../BackLink/BackLink';
import { ManageCookies } from '../ManageCookies/ManageCookies';
import { MessageContainer } from '../MessageContainer/MessageContainer';
import { ContentHolder, FlowStep, FlowStepComponent, TitleContainerWrapper, ViewComponent } from './ViewContainer.styles';
import { DecorativeComponent } from '../DecorativeComponent/DecorativeComponent';
import { isLeftAlignedLayout } from '../../utils/isLeftAlignedLayout';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const ViewContainer = ({
  showMobileView,
  layoutType,
  showBackLink,
  children,
  messagingChildren,
  alignCentredStepAtTheTop,
  backLinkHref,
  onBackLinkClick,
  showManageCookiesLink,
  shouldAddTopPadding,
  titleContainer,
  decorativeBgComponent
}) => {
  const shouldShowBackLink = layoutType === LayoutType.FramedCentredModalStep && !showMobileView && showBackLink;
  const shouldShowMessaging = [LayoutType.TwoColumn, LayoutType.LeftAlignedTwoColumn].includes(layoutType) && messagingChildren;
  const {
    isDesktop
  } = useResponsiveness();
  const shouldShowManageCookiesLink = !isDesktop && showManageCookiesLink;
  const hasTitleContainer = !!titleContainer;
  const renderTitleContainer = () => {
    if (hasTitleContainer) {
      return /*#__PURE__*/_jsx(TitleContainerWrapper, {
        shouldAddTopMargin: isLeftAlignedLayout(layoutType),
        children: titleContainer
      });
    }
  };
  return /*#__PURE__*/_jsxs(ViewComponent, {
    layoutType: layoutType,
    hasTitleContainer: hasTitleContainer,
    children: [renderTitleContainer(), /*#__PURE__*/_jsxs(FlowStep, {
      layoutType: layoutType,
      children: [/*#__PURE__*/_jsx(FlowStepComponent, {
        alignCentredStepAtTheTop: alignCentredStepAtTheTop,
        layoutType: layoutType,
        shouldAddTopPadding: shouldAddTopPadding,
        children: /*#__PURE__*/_jsxs(ContentHolder, {
          alignCentredStepAtTheTop: alignCentredStepAtTheTop,
          layoutType: layoutType,
          id: "content-holder",
          children: [shouldShowBackLink && /*#__PURE__*/_jsx(BackLink, {
            href: backLinkHref,
            onClick: onBackLinkClick
          }), children, decorativeBgComponent && /*#__PURE__*/_jsx(DecorativeComponent, {
            decorativeBgComponent: decorativeBgComponent
          })]
        })
      }), !shouldShowMessaging && shouldShowManageCookiesLink && /*#__PURE__*/_jsx(ManageCookies, {})]
    }), shouldShowMessaging && /*#__PURE__*/_jsxs(MessageContainer, {
      layoutType: layoutType,
      children: [messagingChildren, shouldShowManageCookiesLink && /*#__PURE__*/_jsx(ManageCookies, {})]
    })]
  });
};